import React from 'react';

// External Import
import { common } from "@mui/material/colors";
import KeyboardDoubleArrowUpRoundedIcon from '@mui/icons-material/KeyboardDoubleArrowUpRounded';


export interface ScrollToTopProps { }
export const ScrollToTopComponent: React.FC<ScrollToTopProps> = () => {

    const [scrolled, setScrolled] = React.useState<boolean>(false);

    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 100) {
            setScrolled(true)
        }
        else if (scrolled <= 100) {
            setScrolled(false)
        }
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    window.addEventListener('scroll', toggleVisible);


    return (
        <div onClick={scrollToTop} style={{
            right: 12,
            bottom: 12,
            padding: 10,
            borderRadius: 100,
            cursor: 'pointer',
            position: 'fixed',
            backgroundColor: common.white,
            display: scrolled ? 'flex' : 'none',
            boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px'
        }}>
            <KeyboardDoubleArrowUpRoundedIcon sx={{ fill: '#008060' }} />
        </div>
    )
};